export { default as VideoBlockV2 } from './VideoBlockV2';
export type { VideoBlockV2Props } from './VideoBlockV2';
